<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-on="on" v-bind="attrs">
        <img :src="currentLanguageIcon" v-if="currentLanguageIcon" />
        <v-icon v-else>mdi-earth</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="language in languages"
        :key="language.id"
        @click.prevent="changeLanguage(language.id)"
        dense
      >
        <v-list-item-avatar tile size="32">
          <v-img :src="language.flagSrc"></v-img>
        </v-list-item-avatar>
        <v-list-item-title>{{ language.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    currentLanguage: {
      type: String,
      default: 'pt',
    },
  },
  data() {
    return {
      languages: [
        {
          id: 'pt',
          title: 'Português',
          flagSrc: '/images/logo/pt.png',
        },
        {
          id: 'es',
          title: 'Espanhol',
          flagSrc: '/images/logo/py.png',
        },
      ],
    }
  },
  computed: {
    currentLanguageIcon() {
      if (!this.currentLanguage || !this.currentLanguage) {
        return null
      }
      return this.languages.filter((x) => x.id === this.currentLanguage)[0]
        .flagSrc
    },
  },
  methods: {
    changeLanguage(id) {
      this.$emit('languageChanged', id)
    },
  },
}
</script>
